/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import type { RelevantSearchSourcesResponse } from '../schemas/RelevantSearchSourcesResponse';
import { fetcher, FetcherOptions } from './fetcher';

export type AssetsSavedSearchRelevantSearchSourcesV1RetrieveOkResponse =
  RelevantSearchSourcesResponse;

export type AssetsSavedSearchRelevantSearchSourcesV1RetrieveErrorResponse =
  unknown;

export interface AssetsSavedSearchRelevantSearchSourcesV1RetrieveProps
  extends Omit<FetcherOptions<unknown, unknown>, 'url'> {}

export function assetsSavedSearchRelevantSearchSourcesV1Retrieve(
  props: AssetsSavedSearchRelevantSearchSourcesV1RetrieveProps
): Promise<AssetsSavedSearchRelevantSearchSourcesV1RetrieveOkResponse> {
  return fetcher<
    AssetsSavedSearchRelevantSearchSourcesV1RetrieveOkResponse,
    unknown,
    unknown
  >({
    url: `/assets/saved-search/relevant_search_sources_v1/`,
    method: 'GET',
    ...props
  });
}
